import React from 'react';
import './Footer.css'

function Footer() {
    return (
        <footer>
            <p>&copy; 2024 <a href={"https://veniceprojectcenter.org"}> Venice Project Center</a> & <a href={"https://serendpt.net"}> SerenDPT</a> - All Rights Reserved</p>
        </footer>
    );
}

export default Footer;
